import React, { FC, useState } from 'react'
import classNamesBind from 'classnames/bind'
import { DiscType } from '@dashboard/lib/types'
import { tsErrorHelper } from '@dashboard/lib/playbooks'

import { getDescriptionGeneric, getTitle } from '@dashboard/lib/enneagram'

import css from './styles.module.scss'
const classNames = classNamesBind.bind(css)

export type EnneagramTextType =
  | '1'
  | '2'
  | '3'
  | '4'
  | '5'
  | '6'
  | '7'
  | '8'
  | '9'

interface OwnProps {
  type?: EnneagramTextType
  discType?: DiscType | 'empty'
  /** Width in pixels or percentage */
  width: string
}

const EnneagramSVG: FC<OwnProps> = ({ type, discType, width }: OwnProps) => {
  const [hoveredType, setHoveredType] = useState<number | null>(null)

  // Functions
  const mouseActionHelper = (type: number | null) => {
    setHoveredType(type)
  }

  const isActiveType = (passedType: EnneagramTextType) => {
    return type == passedType || `${hoveredType}` == passedType
  }

  // Partials
  const renderCenterNumber = () => {
    if (!type) return null

    switch (type) {
      case '1':
        return (
          <path
            className={classNames('cls-3', discType)}
            d="M334,354.64v12.92H271.78V354.64h23.79V283.12q0-3.81.24-7.77l-18.32,15.46a5.86,5.86,0,0,1-2.42,1.23,5.12,5.12,0,0,1-2.3,0,6.29,6.29,0,0,1-1.9-.75,5,5,0,0,1-1.31-1.15l-5.31-7.46,34.41-29.57h13.88V354.64Z"
          />
        )
      case '2':
        return (
          <path
            className={classNames('cls-3', discType)}
            d="M331.73,352.58a5.83,5.83,0,0,1,4.36,1.63,5.69,5.69,0,0,1,1.59,4.16v10.31H260.45v-5.79a10.44,10.44,0,0,1,.71-3.64,9.86,9.86,0,0,1,2.3-3.49L299,320.16q4.51-4.53,8-8.65a61.81,61.81,0,0,0,6-8.24,37.61,37.61,0,0,0,3.81-8.37,30.17,30.17,0,0,0,1.3-8.92,21.36,21.36,0,0,0-1.38-8,15.22,15.22,0,0,0-9.6-9.12,23,23,0,0,0-7.41-1.14,22.38,22.38,0,0,0-7.18,1.11,20,20,0,0,0-5.86,3.09,17.71,17.71,0,0,0-4.29,4.72,20.18,20.18,0,0,0-2.49,6A8,8,0,0,1,276.9,287q-1.86,1.11-5.43.48l-9-1.59A43.09,43.09,0,0,1,267,271.71a33.59,33.59,0,0,1,8.29-10.19,35,35,0,0,1,11.46-6.18,45,45,0,0,1,14-2.1,41.65,41.65,0,0,1,14,2.26,32.48,32.48,0,0,1,11,6.42A29.05,29.05,0,0,1,333,272a32.83,32.83,0,0,1,2.62,13.4,35.45,35.45,0,0,1-1.87,11.73,47.74,47.74,0,0,1-5,10.31,72.85,72.85,0,0,1-7.41,9.55q-4.24,4.65-8.92,9.4l-27.6,28.23a60.93,60.93,0,0,1,6.86-1.51,41.27,41.27,0,0,1,6.54-.56Z"
          />
        )
      case '3':
        return (
          <path
            className={classNames('cls-3', discType)}
            d="M263.07,285.9a42.62,42.62,0,0,1,4.48-14.19,33.41,33.41,0,0,1,8.28-10.19,35,35,0,0,1,11.46-6.18,45,45,0,0,1,14-2.1,41.47,41.47,0,0,1,13.84,2.18,32.4,32.4,0,0,1,10.7,6.06,26.39,26.39,0,0,1,6.9,9.28,28.54,28.54,0,0,1,2.42,11.81,32,32,0,0,1-1.31,9.64,23.66,23.66,0,0,1-3.72,7.33,21.47,21.47,0,0,1-5.91,5.31,36.71,36.71,0,0,1-7.85,3.57q10.62,3.09,15.94,9.87t5.31,17A33.42,33.42,0,0,1,334.51,350a32.3,32.3,0,0,1-8.37,10.86,37,37,0,0,1-12.29,6.78A46.67,46.67,0,0,1,299,370a49.2,49.2,0,0,1-15.23-2.1,32.52,32.52,0,0,1-11.06-6,33.77,33.77,0,0,1-7.73-9.47,64.87,64.87,0,0,1-5.23-12.45l7.37-3.09a9.13,9.13,0,0,1,5.59-.72,5.31,5.31,0,0,1,3.85,2.94q1.26,2.54,2.85,5.43a22.41,22.41,0,0,0,4.08,5.31,20.93,20.93,0,0,0,6.19,4,22.38,22.38,0,0,0,9.08,1.63,23.86,23.86,0,0,0,9.55-1.78,21.32,21.32,0,0,0,6.82-4.6,18.7,18.7,0,0,0,4.08-6.31,19,19,0,0,0,1.35-6.89,28.61,28.61,0,0,0-1-7.9,12.46,12.46,0,0,0-4-6.14,21.41,21.41,0,0,0-8.41-4,56.09,56.09,0,0,0-14.23-1.47V304.06a47.35,47.35,0,0,0,12.17-1.47,21.71,21.71,0,0,0,7.93-3.8,13.8,13.8,0,0,0,4.28-5.83,20.68,20.68,0,0,0,1.31-7.45,20.43,20.43,0,0,0-1.35-7.7,15,15,0,0,0-9.51-8.95,23.24,23.24,0,0,0-7.38-1.11,22.27,22.27,0,0,0-7.17,1.11,20,20,0,0,0-5.87,3.09,18.16,18.16,0,0,0-4.32,4.72,19.77,19.77,0,0,0-2.54,6,7.73,7.73,0,0,1-3,4.36q-1.86,1.11-5.43.48Z"
          />
        )
      case '4':
        return (
          <path
            className={classNames('cls-3', discType)}
            d="M338.78,319.81v9.83a3.57,3.57,0,0,1-.91,2.46,3.45,3.45,0,0,1-2.73,1H323V362H308.18V333.13h-49.4a4.74,4.74,0,0,1-3.13-1.07,4.94,4.94,0,0,1-1.71-2.65l-1.74-8.73L307,247.74h16v72.07Zm-30.6,0v-41.7a93.75,93.75,0,0,1,.71-10.95l-38.37,52.65Z"
          />
        )
      case '5':
        return (
          <path
            className={classNames('cls-3', discType)}
            d="M281.54,290a79.45,79.45,0,0,1,7.89-1.27,70.4,70.4,0,0,1,7.25-.4A43.64,43.64,0,0,1,312.5,291a32.62,32.62,0,0,1,11.5,7.33,30.45,30.45,0,0,1,7,11A39,39,0,0,1,333.31,323a42,42,0,0,1-3.17,16.57,37,37,0,0,1-8.8,12.73,39.27,39.27,0,0,1-13.28,8.13,47,47,0,0,1-16.53,2.85,46.29,46.29,0,0,1-9.95-1,47.56,47.56,0,0,1-16.46-6.94,52.58,52.58,0,0,1-6.26-4.87l5.23-7.3a5.18,5.18,0,0,1,4.44-2.38,7.44,7.44,0,0,1,3.81,1.27q2.06,1.28,4.8,2.74a42,42,0,0,0,6.46,2.73,27.5,27.5,0,0,0,8.88,1.27,26.43,26.43,0,0,0,10.07-1.82,20.81,20.81,0,0,0,7.49-5.12,21.87,21.87,0,0,0,4.64-7.89,30.58,30.58,0,0,0,1.59-10.06,25.63,25.63,0,0,0-1.47-9,17.66,17.66,0,0,0-4.36-6.74,19.14,19.14,0,0,0-7.26-4.25,31.75,31.75,0,0,0-10.07-1.46,53.15,53.15,0,0,0-8.6.71,58.11,58.11,0,0,0-8.92,2.22l-10.62-3,9.35-54.55h55.27v7.37a8.08,8.08,0,0,1-2.3,5.95q-2.31,2.3-7.69,2.3H286.14Z"
          />
        )
      case '6':
        return (
          <path
            className={classNames('cls-3', discType)}
            d="M290.58,289.84l-2.42,3c-.77.95-1.52,1.91-2.26,2.86a34.38,34.38,0,0,1,8-3.25,35.06,35.06,0,0,1,9.35-1.19A37.54,37.54,0,0,1,316,293.45a30.67,30.67,0,0,1,10.74,6.5,31.86,31.86,0,0,1,7.42,10.7A36.62,36.62,0,0,1,337,325.36a37.92,37.92,0,0,1-2.89,14.83,36.16,36.16,0,0,1-8.13,12,38.35,38.35,0,0,1-12.57,8.09,46.08,46.08,0,0,1-32.23.12A34.74,34.74,0,0,1,269,352.36a35.14,35.14,0,0,1-7.73-12.49,46.51,46.51,0,0,1-2.7-16.25,44.49,44.49,0,0,1,3.33-16.26,78.28,78.28,0,0,1,10.31-17.84l28.07-37.66a10,10,0,0,1,3.69-2.85,12,12,0,0,1,5.43-1.19h15.06Zm6.26,59.31a25.25,25.25,0,0,0,9.44-1.71,21.69,21.69,0,0,0,7.33-4.71,21,21,0,0,0,4.72-7.14,23.69,23.69,0,0,0,1.66-9,25.78,25.78,0,0,0-1.62-9.4,19.41,19.41,0,0,0-4.6-7,20.27,20.27,0,0,0-7.14-4.4,26.13,26.13,0,0,0-9.16-1.55,23.91,23.91,0,0,0-9.31,1.74,21.31,21.31,0,0,0-7.1,4.76,21.09,21.09,0,0,0-4.52,7.06,23.19,23.19,0,0,0-1.58,8.56,28.73,28.73,0,0,0,1.42,9.28,19.42,19.42,0,0,0,4.21,7.17,19,19,0,0,0,6.85,4.64A24.79,24.79,0,0,0,296.84,349.15Z"
          />
        )
      case '7':
        return (
          <path
            className={classNames('cls-3', discType)}
            d="M333.72,247.82v7.53a16.7,16.7,0,0,1-.71,5.39,28.93,28.93,0,0,1-1.43,3.49l-45.11,91.82a11.65,11.65,0,0,1-3.37,4.24,9.06,9.06,0,0,1-5.75,1.7H265.06l46-90.31c.84-1.64,1.69-3.12,2.53-4.44a32.27,32.27,0,0,1,2.86-3.8h-57a3.76,3.76,0,0,1-2.78-1.23,4,4,0,0,1-1.19-2.82V247.82Z"
          />
        )
      case '8':
        return (
          <path
            className={classNames('cls-3', discType)}
            d="M322.05,301.18q10.54,3.26,15.82,10.31T343.14,329a31.87,31.87,0,0,1-2.85,13.64,29.54,29.54,0,0,1-8,10.38A36.81,36.81,0,0,1,320,359.65a55.19,55.19,0,0,1-31.8,0A36.67,36.67,0,0,1,275.83,353a29.54,29.54,0,0,1-8-10.38A31.72,31.72,0,0,1,265,329q0-10.47,5.28-17.52t15.81-10.31a26.84,26.84,0,0,1-12.88-9.91,27.59,27.59,0,0,1-4.32-15.62A28.35,28.35,0,0,1,278.56,254a34.2,34.2,0,0,1,11.14-6.42,45,45,0,0,1,28.66,0A34.37,34.37,0,0,1,329.47,254a29,29,0,0,1,7.21,9.63,28.06,28.06,0,0,1,2.58,12,27.59,27.59,0,0,1-4.32,15.62A26.87,26.87,0,0,1,322.05,301.18Zm-18,47.33a26.83,26.83,0,0,0,9.2-1.46,18.74,18.74,0,0,0,6.78-4.13,17.64,17.64,0,0,0,4.16-6.3,21.58,21.58,0,0,0,1.43-7.93,22.81,22.81,0,0,0-1.63-9,16.87,16.87,0,0,0-4.52-6.3,18.87,18.87,0,0,0-6.85-3.73,30.44,30.44,0,0,0-17.13,0,18.91,18.91,0,0,0-6.86,3.73,16.87,16.87,0,0,0-4.52,6.3,23,23,0,0,0-1.62,9,21.58,21.58,0,0,0,1.42,7.93,17.53,17.53,0,0,0,4.17,6.3,18.79,18.79,0,0,0,6.77,4.13A26.87,26.87,0,0,0,304.05,348.51Zm0-90.15a21.76,21.76,0,0,0-8.2,1.43,16.62,16.62,0,0,0-5.83,3.8,15.41,15.41,0,0,0-3.45,5.59,19.87,19.87,0,0,0-1.15,6.78,24.89,24.89,0,0,0,1,7,17,17,0,0,0,3.17,6.07,15.42,15.42,0,0,0,5.75,4.24,24.85,24.85,0,0,0,17.44,0,15.34,15.34,0,0,0,5.75-4.24,16.79,16.79,0,0,0,3.17-6.07,24.9,24.9,0,0,0,1-7,20.11,20.11,0,0,0-1.15-6.78,15.24,15.24,0,0,0-3.49-5.59,17.18,17.18,0,0,0-5.83-3.8A21.53,21.53,0,0,0,304.05,258.36Z"
          />
        )
      case '9':
        return (
          <path
            className={classNames('cls-3', discType)}
            d="M304,314.73q1.57-2,2.93-3.76t2.54-3.61a31.59,31.59,0,0,1-9.2,4.48,36.82,36.82,0,0,1-10.78,1.55,34.24,34.24,0,0,1-11.9-2.1A29.63,29.63,0,0,1,267.49,305a30.42,30.42,0,0,1-7.1-10.31,35.36,35.36,0,0,1-2.66-14.15,36,36,0,0,1,2.82-14.19,35.11,35.11,0,0,1,7.89-11.62,37.07,37.07,0,0,1,12.13-7.81,44.46,44.46,0,0,1,31-.12,33.51,33.51,0,0,1,11.74,7.69,34.32,34.32,0,0,1,7.45,11.82,42.14,42.14,0,0,1,2.62,15.1,50,50,0,0,1-.92,9.76,51.59,51.59,0,0,1-2.61,8.92,62.47,62.47,0,0,1-4.13,8.48q-2.42,4.16-5.43,8.44l-26.88,38.54a8.59,8.59,0,0,1-3.53,2.85,12.09,12.09,0,0,1-5.27,1.11H269Zm-29.26-35.44q0,10.15,5.43,15.58t15.19,5.43a23.9,23.9,0,0,0,9.23-1.66,20.31,20.31,0,0,0,6.78-4.48,18.71,18.71,0,0,0,4.2-6.58,22.36,22.36,0,0,0,1.43-8.05,24.22,24.22,0,0,0-1.54-8.92,19.18,19.18,0,0,0-4.37-6.7,18.91,18.91,0,0,0-6.7-4.24A23.75,23.75,0,0,0,296,258.2a22.85,22.85,0,0,0-8.72,1.59,19.65,19.65,0,0,0-6.66,4.4,19.31,19.31,0,0,0-4.28,6.66A22.83,22.83,0,0,0,274.78,279.29Z"
          />
        )

      default:
        tsErrorHelper(type)
    }
  }

  const renderHoverHelper = () => {
    if (!hoveredType) return null

    return (
      <div className={classNames('hover-traits', discType)}>
        <div className={classNames('hover-title', discType)}>
          {getTitle(`${hoveredType}`)}
        </div>
        <div className={classNames('hover-title')}>
          {getDescriptionGeneric(`${hoveredType}`)}
        </div>
      </div>
    )
  }

  return (
    <div className={classNames('container')} style={{ width, minWidth: width }}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 588.84 624.93">
        <title>Type 1</title>
        <g id="grey_circle" data-name="grey circle">
          <ellipse
            className={classNames('cls-1')}
            cx="297.18"
            cy="310.32"
            rx="241.67"
            ry="243.44"
          />
          <polygon
            className={classNames('cls-2')}
            points="58.77 267.79 214.38 537.31 141.57 124.38 535.58 267.79 384.46 537.31 452.79 124.38 58.77 267.79"
          />
          <polygon
            className={classNames('cls-2')}
            points="87.53 430.86 297.18 67.74 506.83 430.86 297.18 430.86 87.53 430.86"
          />
          {/* 1 */}
          <path
            className={classNames('cls-4', discType, {
              active: isActiveType('1'),
            })}
            onMouseOver={() => mouseActionHelper(1)}
            onMouseLeave={() => mouseActionHelper(null)}
            d="M514.66,130.45v4.08H495v-4.08h7.5V107.9c0-.8,0-1.62.07-2.45l-5.78,4.88a1.76,1.76,0,0,1-.76.38,1.61,1.61,0,0,1-.72,0,1.8,1.8,0,0,1-.6-.24,1.69,1.69,0,0,1-.42-.36l-1.67-2.35,10.85-9.33h4.38v32Z"
          />
          {/* 2 */}
          <path
            className={classNames('cls-4', discType, {
              active: isActiveType('2'),
            })}
            onMouseOver={() => mouseActionHelper(2)}
            onMouseLeave={() => mouseActionHelper(null)}
            d="M584.52,279.81a1.59,1.59,0,0,1,1.15.43,1.49,1.49,0,0,1,.42,1.1V284h-23.9v-1.53a2.67,2.67,0,0,1,.2-1,2.89,2.89,0,0,1,.63-.93l11.47-11.52c1-1,1.82-1.9,2.6-2.79a18.88,18.88,0,0,0,2-2.69,12.94,12.94,0,0,0,1.28-2.73,9.62,9.62,0,0,0,.45-3,7.12,7.12,0,0,0-.5-2.76,5.34,5.34,0,0,0-3.4-3.12,8,8,0,0,0-2.53-.39,7.53,7.53,0,0,0-2.52.4,6.7,6.7,0,0,0-2,1.11,6.52,6.52,0,0,0-1.49,1.69,6.86,6.86,0,0,0-.85,2.15,2,2,0,0,1-.81,1.16,2.29,2.29,0,0,1-1.44.16l-2.32-.4a13,13,0,0,1,1.36-4.33,10.66,10.66,0,0,1,2.55-3.17,10.91,10.91,0,0,1,3.51-1.93,13.81,13.81,0,0,1,8.53,0,9.87,9.87,0,0,1,3.42,2,9,9,0,0,1,2.28,3.14,10.19,10.19,0,0,1,.82,4.2,11.15,11.15,0,0,1-.6,3.71,14.8,14.8,0,0,1-1.62,3.26,26.11,26.11,0,0,1-2.36,3c-.9,1-1.84,2-2.84,3l-9.45,9.65a17.27,17.27,0,0,1,2-.43,12.51,12.51,0,0,1,2-.17Z"
          />
          {/* 3 */}
          <path
            className={classNames('cls-4', discType, {
              active: isActiveType('3'),
            })}
            onMouseOver={() => mouseActionHelper(3)}
            onMouseLeave={() => mouseActionHelper(null)}
            d="M539.55,420.37A13.55,13.55,0,0,1,540.9,416a10.56,10.56,0,0,1,2.54-3.16,11,11,0,0,1,3.52-1.94,13.58,13.58,0,0,1,4.29-.66,13.12,13.12,0,0,1,4.2.65,9.75,9.75,0,0,1,3.32,1.85,8.51,8.51,0,0,1,2.16,2.9,9.09,9.09,0,0,1,.77,3.78,9.77,9.77,0,0,1-.43,3,7.28,7.28,0,0,1-1.25,2.34,7.7,7.7,0,0,1-2,1.7,11.39,11.39,0,0,1-2.57,1.15,9.54,9.54,0,0,1,5.26,3.09,8.4,8.4,0,0,1,1.76,5.46,10.33,10.33,0,0,1-.93,4.45A9.92,9.92,0,0,1,559,444a11.26,11.26,0,0,1-3.79,2.13,14.27,14.27,0,0,1-4.63.74,14.64,14.64,0,0,1-4.88-.72,10,10,0,0,1-3.42-2,10.3,10.3,0,0,1-2.3-3,22.51,22.51,0,0,1-1.53-3.71l1.93-.8a2.35,2.35,0,0,1,1.46-.18,1.44,1.44,0,0,1,1,.83c.21.46.49,1,.81,1.67A8,8,0,0,0,545,441a7.19,7.19,0,0,0,2.16,1.52,7.74,7.74,0,0,0,3.34.63,8.22,8.22,0,0,0,3.29-.62,7.09,7.09,0,0,0,2.35-1.58,6.8,6.8,0,0,0,1.41-2.18,6.53,6.53,0,0,0,.47-2.37,8.84,8.84,0,0,0-.37-2.65,4.51,4.51,0,0,0-1.4-2.08,7.35,7.35,0,0,0-2.82-1.37,17.13,17.13,0,0,0-4.58-.5v-3.23a14.58,14.58,0,0,0,3.91-.5,7.36,7.36,0,0,0,2.63-1.3,4.94,4.94,0,0,0,1.47-2,6.77,6.77,0,0,0,.46-2.55,6.93,6.93,0,0,0-.48-2.7,5.3,5.3,0,0,0-1.34-1.9,5.67,5.67,0,0,0-2-1.13,8.21,8.21,0,0,0-2.52-.37,7.59,7.59,0,0,0-2.51.4,6.43,6.43,0,0,0-2,1.11A6.52,6.52,0,0,0,545,417.3a6.76,6.76,0,0,0-.85,2.15,2.1,2.1,0,0,1-.81,1.16,2.26,2.26,0,0,1-1.41.16Z"
          />
          {/* 4 */}
          <path
            className={classNames('cls-4', discType, {
              active: isActiveType('4'),
            })}
            onMouseOver={() => mouseActionHelper(4)}
            onMouseLeave={() => mouseActionHelper(null)}
            d="M398,598.58v2.55a1,1,0,0,1-.24.67.9.9,0,0,1-.74.28h-4.45v9.42h-3.9v-9.42h-15.9a1.35,1.35,0,0,1-.86-.29,1.28,1.28,0,0,1-.46-.71L371,598.8l17.42-23.12h4.15v22.9Zm-9.33,0V583.8c0-.43,0-.91.05-1.42s.09-1,.15-1.58l-13.05,17.78Z"
          />
          {/* 5 */}
          <path
            className={classNames('cls-4', discType, {
              active: isActiveType('5'),
            })}
            onMouseOver={() => mouseActionHelper(5)}
            onMouseLeave={() => mouseActionHelper(null)}
            d="M206.72,589.2a24.8,24.8,0,0,1,5.15-.6,13.73,13.73,0,0,1,4.95.83,10.07,10.07,0,0,1,3.59,2.27,9.51,9.51,0,0,1,2.17,3.43,12,12,0,0,1,.74,4.3,12.89,12.89,0,0,1-1,5.15,11.63,11.63,0,0,1-2.72,3.94,12,12,0,0,1-4.09,2.51,14.48,14.48,0,0,1-5.07.87,14.28,14.28,0,0,1-3-.31,15.88,15.88,0,0,1-2.71-.84,16.06,16.06,0,0,1-2.34-1.2,13.82,13.82,0,0,1-1.9-1.42l1.38-1.9a1.37,1.37,0,0,1,1.17-.65,2.19,2.19,0,0,1,1.13.39c.41.25.92.54,1.52.86a13,13,0,0,0,2.12.86,9.42,9.42,0,0,0,2.88.39,9,9,0,0,0,3.38-.6,7.24,7.24,0,0,0,2.57-1.71,7.52,7.52,0,0,0,1.65-2.67,9.75,9.75,0,0,0,.58-3.47,8.76,8.76,0,0,0-.49-3,6,6,0,0,0-1.47-2.3,6.79,6.79,0,0,0-2.47-1.47,10.25,10.25,0,0,0-3.45-.53,18.55,18.55,0,0,0-2.81.23,19.33,19.33,0,0,0-3,.72l-2.8-.82,2.88-16.75h17v2a2.17,2.17,0,0,1-.58,1.56,2.74,2.74,0,0,1-2,.61H208.37Z"
          />
          {/* 7 */}
          <path
            className={classNames('cls-4', discType, {
              active: isActiveType('7'),
            })}
            onMouseOver={() => mouseActionHelper(7)}
            onMouseLeave={() => mouseActionHelper(null)}
            d="M27,248.21v2a4.5,4.5,0,0,1-.19,1.4,9.46,9.46,0,0,1-.37.93L11.62,282.46a3.14,3.14,0,0,1-.9,1.12A2.39,2.39,0,0,1,9.2,284H6l15.05-29.55c.22-.42.44-.8.67-1.15s.49-.69.75-1H3.78A1,1,0,0,1,3,252a1.06,1.06,0,0,1-.33-.76v-3Z"
          />
          {/* 8 */}
          <path
            className={classNames('cls-4', discType, {
              active: isActiveType('8'),
            })}
            onMouseOver={() => mouseActionHelper(8)}
            onMouseLeave={() => mouseActionHelper(null)}
            d="M89.63,116.82A9.81,9.81,0,0,1,94.78,120a8.76,8.76,0,0,1,1.8,5.7,9.86,9.86,0,0,1-.89,4.23,9.32,9.32,0,0,1-2.48,3.22,11.11,11.11,0,0,1-3.81,2,17,17,0,0,1-9.8,0,11.25,11.25,0,0,1-3.82-2,9.08,9.08,0,0,1-2.48-3.22,10,10,0,0,1-.87-4.23,8.76,8.76,0,0,1,1.8-5.7,9.77,9.77,0,0,1,5.15-3.18,8.12,8.12,0,0,1-5.7-8.12,9,9,0,0,1,.77-3.7,8.9,8.9,0,0,1,2.2-3,10.38,10.38,0,0,1,3.41-2,13.84,13.84,0,0,1,8.87,0,10.32,10.32,0,0,1,3.42,2,8.77,8.77,0,0,1,2.2,3,8.86,8.86,0,0,1,.78,3.7,8.55,8.55,0,0,1-1.44,5A8.67,8.67,0,0,1,89.63,116.82ZM84.5,132.35a9.58,9.58,0,0,0,3.14-.49A6.83,6.83,0,0,0,90,130.48a6,6,0,0,0,1.47-2.12,7,7,0,0,0,.52-2.74,7.39,7.39,0,0,0-.62-3.16,5.62,5.62,0,0,0-1.65-2.14,6.78,6.78,0,0,0-2.38-1.21,10.43,10.43,0,0,0-5.65,0,6.83,6.83,0,0,0-2.39,1.21,5.83,5.83,0,0,0-1.65,2.14,7.39,7.39,0,0,0-.61,3.16,7.15,7.15,0,0,0,.51,2.74A6,6,0,0,0,79,130.48a6.92,6.92,0,0,0,2.35,1.38A9.58,9.58,0,0,0,84.5,132.35Zm0-29.63a7.62,7.62,0,0,0-2.81.48,5.72,5.72,0,0,0-2,1.3,5.29,5.29,0,0,0-1.22,1.92,6.53,6.53,0,0,0-.41,2.35,7.93,7.93,0,0,0,.35,2.38,5.54,5.54,0,0,0,1.12,2,5.68,5.68,0,0,0,2,1.43,8.55,8.55,0,0,0,6,0,5.43,5.43,0,0,0,3.14-3.46,8.26,8.26,0,0,0,.35-2.38,6.53,6.53,0,0,0-.42-2.35,5.29,5.29,0,0,0-1.22-1.92,5.63,5.63,0,0,0-2-1.3A7.55,7.55,0,0,0,84.5,102.72Z"
          />
          {/* 6 */}
          <path
            className={classNames('cls-4', discType, {
              active: isActiveType('6'),
            })}
            onMouseOver={() => mouseActionHelper(6)}
            onMouseLeave={() => mouseActionHelper(null)}
            d="M32.25,424.1c-.32.4-.62.78-.91,1.16s-.58.74-.84,1.11A10.51,10.51,0,0,1,33.3,425a11.29,11.29,0,0,1,3.32-.47,11.59,11.59,0,0,1,4.1.71,9.77,9.77,0,0,1,3.37,2.07,10,10,0,0,1,2.28,3.35,11.42,11.42,0,0,1,.85,4.54,11.68,11.68,0,0,1-.9,4.6,11.13,11.13,0,0,1-2.51,3.7A11.64,11.64,0,0,1,39.94,446a13.42,13.42,0,0,1-5,.9,13.2,13.2,0,0,1-4.9-.87,10.36,10.36,0,0,1-3.74-2.45,10.74,10.74,0,0,1-2.37-3.85,14.4,14.4,0,0,1-.84-5.06,13.62,13.62,0,0,1,1-5A24.19,24.19,0,0,1,27.45,424l9.1-12.22a2.79,2.79,0,0,1,1-.77,3.18,3.18,0,0,1,1.41-.31h3.95Zm2.6,19.1a8.89,8.89,0,0,0,3.26-.58,7.11,7.11,0,0,0,2.5-1.6,7,7,0,0,0,1.6-2.42,8,8,0,0,0,.56-3.05,8.64,8.64,0,0,0-.55-3.17,6.57,6.57,0,0,0-1.56-2.4,6.94,6.94,0,0,0-2.41-1.51,8.73,8.73,0,0,0-3.08-.52,8.26,8.26,0,0,0-3.25.61,7.6,7.6,0,0,0-2.46,1.65,7.24,7.24,0,0,0-1.55,2.4,7.63,7.63,0,0,0-.54,2.84,9.55,9.55,0,0,0,.5,3.15,6.88,6.88,0,0,0,1.47,2.45,6.45,6.45,0,0,0,2.35,1.58A8.21,8.21,0,0,0,34.85,443.2Z"
          />
          {/* 1 Circle */}
          <circle
            className={classNames('cls-7', discType, {
              active: isActiveType('1'),
            })}
            onMouseOver={() => mouseActionHelper(1)}
            onMouseLeave={() => mouseActionHelper(null)}
            cx="453.18"
            cy="124.38"
            r="12.63"
          />
          {/* 8 Circle */}
          <circle
            className={classNames('cls-7', discType, {
              active: isActiveType('8'),
            })}
            onMouseOver={() => mouseActionHelper(8)}
            onMouseLeave={() => mouseActionHelper(null)}
            cx="142.51"
            cy="124.38"
            r="12.63"
          />
          {/* 7 Circle */}
          <circle
            className={classNames('cls-7', discType, {
              active: isActiveType('7'),
            })}
            onMouseOver={() => mouseActionHelper(7)}
            onMouseLeave={() => mouseActionHelper(null)}
            cx="58.78"
            cy="267.41"
            r="12.63"
          />
          {/* 6 Circle */}
          <circle
            className={classNames('cls-7', discType, {
              active: isActiveType('6'),
            })}
            onMouseOver={() => mouseActionHelper(6)}
            onMouseLeave={() => mouseActionHelper(null)}
            cx="87.53"
            cy="430.86"
            r="12.63"
          />
          {/* 5 Circle */}
          <circle
            className={classNames('cls-7', discType, {
              active: isActiveType('5'),
            })}
            onMouseOver={() => mouseActionHelper(5)}
            onMouseLeave={() => mouseActionHelper(null)}
            cx="215.67"
            cy="537.31"
            r="12.63"
          />
          {/* 4 Circle */}
          <circle
            className={classNames('cls-7', discType, {
              active: isActiveType('4'),
            })}
            onMouseOver={() => mouseActionHelper(4)}
            onMouseLeave={() => mouseActionHelper(null)}
            cx="384.46"
            cy="537.31"
            r="12.63"
          />
          {/* 3 Circle */}
          <circle
            className={classNames('cls-7', discType, {
              active: isActiveType('3'),
            })}
            onMouseOver={() => mouseActionHelper(3)}
            onMouseLeave={() => mouseActionHelper(null)}
            cx="506.83"
            cy="430.86"
            r="12.63"
          />
          {/* 2 Circle */}
          <circle
            className={classNames('cls-7', discType, {
              active: isActiveType('2'),
            })}
            onMouseOver={() => mouseActionHelper(2)}
            onMouseLeave={() => mouseActionHelper(null)}
            cx="533.85"
            cy="267.41"
            r="12.63"
          />
          {/* 9 */}
          <path
            className={classNames('cls-4', discType, {
              active: isActiveType('9'),
            })}
            onMouseOver={() => mouseActionHelper(9)}
            onMouseLeave={() => mouseActionHelper(null)}
            d="M302,28.64c.37-.49.71-.94,1-1.38s.61-.86.9-1.3a10,10,0,0,1-3.1,1.68,11.57,11.57,0,0,1-3.65.57,10.92,10.92,0,0,1-3.84-.67,9.19,9.19,0,0,1-3.19-2A9.47,9.47,0,0,1,288,22.33a11.2,11.2,0,0,1-.81-4.39,10.94,10.94,0,0,1,.88-4.4A10.82,10.82,0,0,1,290.5,10a11.71,11.71,0,0,1,3.75-2.4A12.73,12.73,0,0,1,299,6.69a12.31,12.31,0,0,1,4.68.85,10.24,10.24,0,0,1,5.91,6,13.14,13.14,0,0,1,.81,4.7,13.83,13.83,0,0,1-.29,2.94,16.1,16.1,0,0,1-.82,2.73A21,21,0,0,1,308,26.58c-.52.87-1.1,1.77-1.75,2.68l-8.73,12.6a2.25,2.25,0,0,1-.92.76,3,3,0,0,1-1.38.29h-4.1Zm-10.4-11a8.69,8.69,0,0,0,.49,3,6.05,6.05,0,0,0,1.4,2.26,5.8,5.8,0,0,0,2.22,1.4,8.55,8.55,0,0,0,2.94.48,8.17,8.17,0,0,0,3.19-.59,7.16,7.16,0,0,0,2.34-1.56,6.85,6.85,0,0,0,1.45-2.25,7.29,7.29,0,0,0,.5-2.65,8.19,8.19,0,0,0-.54-3,6.72,6.72,0,0,0-1.49-2.31,6.38,6.38,0,0,0-2.26-1.46,7.74,7.74,0,0,0-2.89-.52,8,8,0,0,0-3,.54,6.9,6.9,0,0,0-2.32,1.49,6.43,6.43,0,0,0-1.5,2.27A7.83,7.83,0,0,0,291.62,17.61Z"
          />
          {renderCenterNumber()}
          {/* 9 Circle */}
          <circle
            className={classNames('cls-7', discType, {
              active: isActiveType('9'),
            })}
            onMouseOver={() => mouseActionHelper(9)}
            onMouseLeave={() => mouseActionHelper(null)}
            cx="297.18"
            cy="67.74"
            r="12.63"
          />
        </g>
      </svg>
      {renderHoverHelper()}
    </div>
  )
}

export default EnneagramSVG
